import { useEffect, useRef } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { getDatasetEnvironmentRegistry } from '~/engine/scene/datasetEnvironmentRegistryInstance';
import { currentStructureSetState } from '~/state/atoms/structureSet/structureSetAtoms';
import {
    gridRowImagesState,
    referenceComparisonState,
} from '~/state/atoms/viewportGridAtoms';

// Ends the reference comparison once its row is closed, or once a set the user activates on its image replaces it.
export function useReferenceRowLifecycle(): void {
    const comparison = useRecoilValue(referenceComparisonState);
    const setComparison = useSetRecoilState(referenceComparisonState);
    const rows = useRecoilValue(gridRowImagesState);
    const activeSet = useRecoilValue(currentStructureSetState);
    const seenInRows = useRef<string | undefined>(undefined);

    const seriesUid = comparison?.seriesUid;
    const shownInRow = !!seriesUid && rows.some((uid) => uid === seriesUid);
    useEffect(() => {
        if (!seriesUid) {
            seenInRows.current = undefined;
            return;
        }
        if (shownInRow) {
            seenInRows.current = seriesUid;
        }
        const closed = seenInRows.current === seriesUid && !shownInRow;
        const entry = getDatasetEnvironmentRegistry().entryFor(seriesUid);
        // The registry drops a reference when a set is activated on its image.
        const replaced = !!entry?.structureSet && !entry.reference;
        if (closed || replaced) {
            seenInRows.current = undefined;
            if (closed) {
                getDatasetEnvironmentRegistry().setReference(undefined);
            }
            setComparison(null);
        }
    }, [seriesUid, shownInRow, activeSet, setComparison]);
}
